import { useEffect, useRef, useState } from 'react';
import { t } from '../i18n';

const API = '/api/merchants';
function authHeaders() {
  const token = localStorage.getItem('token');
  return { 'Content-Type': 'application/json', ...(token ? { Authorization: `Token ${token}` } : {}) };
}
const C = { bg: '#FCFCFA', surface: '#fff', border: '#E3E1D9', text: '#2C2C2A', muted: '#5F5E5A', primary: '#0F6E56' };
const btn = { padding: '8px 16px', fontSize: 13, fontWeight: 600, border: 'none', borderRadius: 8, background: C.primary, color: '#fff', cursor: 'pointer' };
const btnGhost = { ...btn, background: '#fff', color: C.text, border: `0.5px solid ${C.border}` };
const COLORS = ['#0F6E56', '#185FA5', '#993C1D', '#993556', '#3B6D11', '#2C2C2A', '#0D9488', '#C0392B'];
const ICONS = ['●', '◆', '★', '▲', '■', '❖', '✦', '➤'];

const ASSETS = [
  { id: 'card', name: 'Visiting card', w: 1050, h: 600, dim: '1050×600 (3.5″×2″ @300dpi)', tier: 'all' },
  { id: 'letter', name: 'Letterhead A4', w: 2480, h: 3508, dim: 'A4 @300dpi', tier: 'full' },
  { id: 'fb', name: 'Facebook cover', w: 1640, h: 624, dim: '1640×624', tier: 'full' },
  { id: 'tw', name: 'X / Twitter header', w: 1500, h: 500, dim: '1500×500', tier: 'full' },
  { id: 'li', name: 'LinkedIn banner', w: 1584, h: 396, dim: '1584×396', tier: 'full' },
  { id: 'yt', name: 'YouTube channel art', w: 2560, h: 1440, dim: '2560×1440', tier: 'full' },
  { id: 'ig', name: 'Instagram post', w: 1080, h: 1080, dim: '1080×1080', tier: 'full' },
  { id: 'wa', name: 'WhatsApp profile', w: 640, h: 640, dim: '640×640', tier: 'full' },
];

export default function BrandKit() {
  const [data, setData] = useState(null);
  const [color, setColor] = useState('#0F6E56');
  const [logoMode, setLogoMode] = useState('generate'); // generate | upload
  const [shape, setShape] = useState('circle');
  const [icon, setIcon] = useState('●');
  const [uploadImg, setUploadImg] = useState(null);
  const [tick, setTick] = useState(0);

  useEffect(() => {
    fetch(`${API}/brandkit/`, { headers: authHeaders() }).then((r) => r.json()).then((d) => {
      if (d.error) { setData({ error: d.error }); return; }
      setData(d); setColor(d.brand_color || '#0F6E56');
      if (d.logo) { const im = new Image(); im.crossOrigin = 'anonymous'; im.onload = () => { setUploadImg(im); setLogoMode('upload'); setTick((t) => t + 1); }; im.src = d.logo; }
    }).catch(() => setData({ error: t('bk_load_failed') }));
  }, []);

  if (!localStorage.getItem('token')) return <p style={{ padding: '2rem' }}>{t('bk_login')}</p>;
  if (!data) return <p style={{ padding: '2rem', fontSize: 13, color: C.muted }}>{t('loading')}</p>;
  if (data.error) return <p style={{ padding: '2rem', fontSize: 14, color: '#A32D2D' }}>{data.error} — pehle merchant register karein.</p>;

  const onUpload = (e) => {
    const f = e.target.files[0]; if (!f) return;
    const r = new FileReader();
    r.onload = (ev) => { const im = new Image(); im.onload = () => { setUploadImg(im); setLogoMode('upload'); setTick((t) => t + 1); }; im.src = ev.target.result; };
    r.readAsDataURL(f);
  };

  const initials = (data.business_name || 'X').trim().split(/\s+/).map((w) => w[0]).join('').slice(0, 2).toUpperCase();

  const drawLogo = (ctx, cx, cy, size) => {
    if (logoMode === 'upload' && uploadImg) {
      const ar = uploadImg.width / uploadImg.height; let w = size, h = size;
      if (ar > 1) h = size / ar; else w = size * ar;
      ctx.drawImage(uploadImg, cx - w / 2, cy - h / 2, w, h); return;
    }
    const r = size / 2;
    ctx.fillStyle = color;
    if (shape === 'circle') { ctx.beginPath(); ctx.arc(cx, cy, r, 0, 7); ctx.fill(); }
    else if (shape === 'square') { const rad = size * 0.18; roundRect(ctx, cx - r, cy - r, size, size, rad); ctx.fill(); }
    else { ctx.beginPath(); for (let i = 0; i < 6; i++) { const a = Math.PI / 180 * (60 * i - 90); const x = cx + r * Math.cos(a), y = cy + r * Math.sin(a); i ? ctx.lineTo(x, y) : ctx.moveTo(x, y); } ctx.closePath(); ctx.fill(); }
    ctx.fillStyle = '#fff';
    if (icon === 'text') { ctx.font = `700 ${size * 0.4}px Arial`; }
    else { ctx.font = `${size * 0.5}px Arial`; }
    ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
    ctx.fillText(icon === 'text' ? initials : icon, cx, cy + size * 0.02);
  };
  // Matn dabbe me na samaye to font chhota karo, phir bhi na samaye to kaat do.
  // Bina is ke lamba email card se bahar nikal jata hai.
  const fitText = (ctx, text, x, y, maxW, size, weight, alpha) => {
    if (!text) return;
    let s = size;
    ctx.globalAlpha = alpha == null ? 1 : alpha;
    ctx.font = `${weight || 400} ${s}px Arial`;
    while (ctx.measureText(text).width > maxW && s > size * 0.62) {
      s -= 0.5;
      ctx.font = `${weight || 400} ${s}px Arial`;
    }
    let out = text;
    if (ctx.measureText(out).width > maxW) {
      while (out.length > 3 && ctx.measureText(out + '…').width > maxW) out = out.slice(0, -1);
      out += '…';
    }
    ctx.fillText(out, x, y);
    ctx.globalAlpha = 1;
  };


  const shade = (hex, f) => { const n = parseInt(hex.slice(1), 16); let r = (n >> 16) & 255, g = (n >> 8) & 255, b = n & 255; return `rgb(${Math.round(r * f)},${Math.round(g * f)},${Math.round(b * f)})`; };

  const render = (a) => {
    const cv = document.createElement('canvas'); cv.width = a.w; cv.height = a.h;
    const ctx = cv.getContext('2d'); const W = a.w, H = a.h;
    const name = data.business_name || 'Business', tag = data.tagline;
    ctx.fillStyle = '#fff'; ctx.fillRect(0, 0, W, H);
    if (a.id === 'card') {
      // Visiting card ki sab se ahem cheez insaan ka naam hai, business ka nahi.
      // Is liye owner_name sab se bara, designation us ke neeche.
      const band = W * 0.34;
      ctx.fillStyle = color; ctx.fillRect(0, 0, band, H);
      drawLogo(ctx, band / 2, H * 0.36, H * 0.32);

      ctx.textAlign = 'center'; ctx.fillStyle = '#fff';
      fitText(ctx, name, band / 2, H * 0.70, band * 0.86, H * 0.072, 600);
      if (tag) fitText(ctx, tag, band / 2, H * 0.81, band * 0.86, H * 0.046, 400, 0.85);

      const x = W * 0.40, maxW = W * 0.55;
      let y = H * 0.22;

      if (data.owner_name) {
        ctx.textAlign = 'left'; ctx.fillStyle = '#131C19';
        fitText(ctx, data.owner_name, x, y, maxW, H * 0.105, 700);
        y += H * 0.115;
      }
      if (data.designation) {
        ctx.textAlign = 'left'; ctx.fillStyle = color;
        fitText(ctx, data.designation, x, y, maxW, H * 0.055, 500);
        y += H * 0.075;
      }

      if (data.owner_name || data.designation) {
        ctx.strokeStyle = color; ctx.lineWidth = Math.max(1, H * 0.008);
        ctx.beginPath(); ctx.moveTo(x, y); ctx.lineTo(x + W * 0.10, y); ctx.stroke();
        y += H * 0.085;
      }

      const lines = [
        data.phone,
        data.email,
        data.website,
        data.address,
        [data.city, data.country].filter(Boolean).join(', '),
      ].filter(Boolean);

      // Jagah utni hi hai jitni hai — jo samaye wahi likho
      const room = H * 0.90 - y;
      const step = Math.min(H * 0.085, room / Math.max(1, lines.length));
      ctx.textAlign = 'left'; ctx.fillStyle = '#5F5E5A';
      lines.forEach((tx) => {
        fitText(ctx, tx, x, y, maxW, Math.min(H * 0.05, step * 0.62), 400);
        y += step;
      });

    } else if (a.id === 'letter') {
      ctx.fillStyle = color; ctx.fillRect(0, 0, W, H * 0.045);
      drawLogo(ctx, W * 0.12, H * 0.115, H * 0.075);
      ctx.fillStyle = '#2C2C2A'; ctx.font = `600 ${H * 0.026}px Arial`; ctx.textAlign = 'left';
      fitText(ctx, name, W * 0.2, H * 0.105, W * 0.7, H * 0.026, 600);
      if (tag) { ctx.font = `${H * 0.015}px Arial`; ctx.fillStyle = shade(color, 0.9); ctx.fillText(tag, W * 0.2, H * 0.135); }
      ctx.strokeStyle = color; ctx.lineWidth = 4; ctx.beginPath(); ctx.moveTo(W * 0.08, H * 0.17); ctx.lineTo(W * 0.92, H * 0.17); ctx.stroke();
      ctx.fillStyle = color; ctx.fillRect(0, H * 0.955, W, H * 0.045);
      ctx.fillStyle = '#fff'; ctx.font = `${H * 0.013}px Arial`; ctx.textAlign = 'center';
      ctx.fillText([data.phone, data.email, data.website].filter(Boolean).join('   •   '), W / 2, H * 0.982);
    } else if (a.id === 'ig' || a.id === 'wa') {
      ctx.fillStyle = color; ctx.fillRect(0, 0, W, H);
      ctx.fillStyle = shade(color, 0.8); ctx.beginPath(); ctx.arc(W / 2, H / 2, W * 0.42, 0, 7); ctx.fill();
      drawLogo(ctx, W / 2, H * 0.42, W * 0.32);
      ctx.fillStyle = '#fff'; ctx.font = `600 ${W * 0.06}px Arial`; ctx.textAlign = 'center';
      fitText(ctx, name, W / 2, H * 0.72, W * 0.8, W * 0.06, 600);
      if (tag) { ctx.font = `${W * 0.035}px Arial`; ctx.globalAlpha = 0.9; ctx.fillText(tag, W / 2, H * 0.79); ctx.globalAlpha = 1; }
    } else {
      ctx.fillStyle = color; ctx.fillRect(0, 0, W, H);
      ctx.fillStyle = shade(color, 0.8);
      ctx.beginPath(); ctx.moveTo(W * 0.62, 0); ctx.lineTo(W, 0); ctx.lineTo(W, H); ctx.lineTo(W * 0.5, H); ctx.closePath(); ctx.fill();
      drawLogo(ctx, W * 0.18, H * 0.5, H * 0.5);
      ctx.fillStyle = '#fff'; ctx.textAlign = 'left'; ctx.font = `700 ${H * 0.15}px Arial`;
      fitText(ctx, name, W * 0.32, H * 0.48, W * 0.6, H * 0.15, 700);
      if (tag) { ctx.font = `${H * 0.08}px Arial`; ctx.globalAlpha = 0.9; ctx.fillText(tag, W * 0.32, H * 0.62); ctx.globalAlpha = 1; }
      ctx.font = `${H * 0.06}px Arial`; ctx.globalAlpha = 0.85;
      ctx.fillText([data.website, data.phone].filter(Boolean).join('  •  '), W * 0.32, H * 0.78); ctx.globalAlpha = 1;
    }
    return cv;
  };

  const download = (a) => {
    render(a).toBlob((b) => { const u = URL.createObjectURL(b); const link = document.createElement('a'); link.href = u; link.download = `${a.id}_${a.w}x${a.h}.png`; link.click(); setTimeout(() => URL.revokeObjectURL(u), 4000); }, 'image/png');
  };

  const saveColor = () => fetch(`${API}/brandkit/save-color/`, { method: 'POST', headers: authHeaders(), body: JSON.stringify({ brand_color: color }) });

  const visible = ASSETS.filter((a) => a.tier === 'all' || data.full_kit);

  return (
    <div style={{ maxWidth: 900, margin: '0 auto', padding: '1.5rem', fontFamily: 'sans-serif', background: C.bg, minHeight: '100vh' }}>
      <h1 style={{ fontSize: 22, margin: '0 0 4px' }}>🎨 Brand Kit</h1>
      <p style={{ fontSize: 13, color: C.muted, margin: '0 0 4px' }}>{data.business_name} · {data.plan} plan</p>
      {!data.full_kit && <p style={{ fontSize: 12, color: '#C0392B', margin: '0 0 12px' }}>{t('bk_upgrade_note')}</p>}

      <div style={{ background: C.surface, border: `0.5px solid ${C.border}`, borderRadius: 12, padding: '1rem', marginBottom: 16 }}>
        <p style={{ fontSize: 13, fontWeight: 600, margin: '0 0 8px' }}>{t('bk_logo')}</p>
        <div style={{ display: 'flex', gap: 8, marginBottom: 10 }}>
          <button style={logoMode === 'generate' ? btn : btnGhost} onClick={() => { setLogoMode('generate'); setTick((t) => t + 1); }}>{t('bk_generate')}</button>
          <label style={{ ...btnGhost, display: 'inline-flex', alignItems: 'center' }}>{t('bk_upload')}<input type="file" accept="image/*" onChange={onUpload} style={{ display: 'none' }} /></label>
        </div>
        {logoMode === 'generate' && (
          <div>
            <p style={{ fontSize: 12, color: C.muted, margin: '0 0 4px' }}>{t('bk_shape')}</p>
            <div style={{ display: 'flex', gap: 6, marginBottom: 8 }}>
              {['circle', 'square', 'hex'].map((s) => <button key={s} onClick={() => { setShape(s); setTick((t) => t + 1); }} style={{ ...(shape === s ? btn : btnGhost), padding: '5px 12px' }}>{s}</button>)}
            </div>
            <p style={{ fontSize: 12, color: C.muted, margin: '0 0 4px' }}>{t('bk_symbol')}</p>
            <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginBottom: 8 }}>
              <button onClick={() => { setIcon('text'); setTick((t) => t + 1); }} style={{ ...(icon === 'text' ? btn : btnGhost), padding: '5px 12px' }}>{t('bk_initials')}</button>
              {ICONS.map((ic) => <button key={ic} onClick={() => { setIcon(ic); setTick((t) => t + 1); }} style={{ ...(icon === ic ? btn : btnGhost), padding: '5px 12px', fontSize: 16 }}>{ic}</button>)}
            </div>
          </div>
        )}
        <p style={{ fontSize: 12, color: C.muted, margin: '0 0 4px' }}>{t('bk_brand_color')}</p>
        <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
          {COLORS.map((c) => <button key={c} onClick={() => { setColor(c); saveColor(); setTick((t) => t + 1); }} style={{ width: 28, height: 28, borderRadius: '50%', background: c, border: color === c ? '3px solid #2C2C2A' : '2px solid #fff', cursor: 'pointer' }} />)}
        </div>
      </div>

      <div key={tick} style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: 14 }}>
        {visible.map((a) => (
          <div key={a.id} style={{ background: C.surface, border: `0.5px solid ${C.border}`, borderRadius: 12, padding: 12 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
              <div><div style={{ fontSize: 14, fontWeight: 500 }}>{a.name}</div><div style={{ fontSize: 11, color: C.muted }}>{a.dim}</div></div>
              <button style={{ ...btn, padding: '6px 12px' }} onClick={() => download(a)}>⬇</button>
            </div>
            <PreviewCanvas render={() => render(a)} />
          </div>
        ))}
      </div>
    </div>
  );
}

function roundRect(ctx, x, y, w, h, r) { ctx.beginPath(); ctx.moveTo(x + r, y); ctx.arcTo(x + w, y, x + w, y + h, r); ctx.arcTo(x + w, y + h, x, y + h, r); ctx.arcTo(x, y + h, x, y, r); ctx.arcTo(x, y, x + w, y, r); ctx.closePath(); }

function PreviewCanvas({ render }) {
  const ref = useRef(null);
  useEffect(() => { const src = render(); const el = ref.current; if (el) { el.width = src.width; el.height = src.height; el.getContext('2d').drawImage(src, 0, 0); } });
  return <canvas ref={ref} style={{ width: '100%', borderRadius: 6, border: '0.5px solid #E3E1D9', display: 'block' }} />;
}
